import styled from 'styled-components';

export const StyledUploadImage = styled.div`
  width: 100%;
  max-width: 80px;
  margin: 0 0 25px;
  /* position: relative; */

  .label-text {
    display: block;
    font-size: 20px;
    line-height: 24px;
    text-transform: capitalize;
    color: var(--matte-black);
    margin: 0 0 8px;
  }

  .labelButton {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    overflow: hidden;
    cursor: pointer;
    border-radius: 50px;
    background: ${({ $bg }) => ($bg ? 'var(--white)' : '#FAFAFA')};
    position: relative;

    &:hover {
    }

    .upload-text {
      display: block;
      text-align: center;
      font-size: 12px;
      line-height: 16px;
      font-weight: 300;
      color: var(--matte-black);

      .icon-img {
        display: block;
        width: 100%;
        height: auto;
      }
    }

    .camera {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  input {
    display: none;
  }

  img {
    display: block;
    max-width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .uploaded-file-name {
    font-weight: 600;
  }
`;
